import http from "../../../../../services/http.service";
import Vessel from "../models/vessel.entity";

class VesselService {
  public saveVehicleData(vessel: Vessel) {
    return http.post('v1/inspection/vessels', vessel.formatPayload());
  }
}

export default new VesselService();
